<script>

import { API_PAY } from '../../common/api'

export default {
  name: 'UserPayUpdate',
  props: ["pay_id"],
  data () {
    return {
      payForm: {
        id: 0,
        user_name: '',
        number: '',
        last_amount: '',
        now_amount: '',
        use_amount: '',
        money: '',
        real_money: ''
      },
      rules: {
        last_amount: [
          { required: true, message: '上次表底不能为空', trigger: 'blur' }
        ],
        now_amount: [
          { required: true, message: '本次表底不能为空', trigger: 'blur' }
        ],
        use_amount: [
          { required: true, message: '用水量不能为空', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '水费不能为空', trigger: 'blur' }
        ],
        real_money: [
          { required: true, message: '实收水费不能为空', trigger: 'blur' }
        ]
      },
      isLoading: false
    }
  },
  created () {
    this.selectUserPay()
  },
  methods: {
    selectUserPay () {
      this.loading = true
      this.$http.GET(API_PAY + '/' + this.pay_id, null,
      res => {
        this.payForm = res.result.data
        console.log(this.payForm)
        this.loading = false
      }, err => {
        this.$message.error(err.msg)
        this.loading = false
      })
    },
    closeUpdate () {
      this.$emit('closeUpdate')
    },
    updateUserPay (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = {
            last_amount: this.payForm.last_amount,
            now_amount: this.payForm.now_amount,
            use_amount: this.payForm.use_amount,
            money: this.payForm.money,
            real_money: this.payForm.real_money,
          }
          this.$http.PUT(API_PAY + '/' + this.pay_id, params,
          res => {
            this.isLoading = false
            this.$emit('updateSuccess')
          }, err => {
            this.isLoading = false
            this.$message.error(err.msg)
          })
        }
      })
    }
  }
}
</script>

<template>
  <div>
    <el-form v-loading="loading" ref="payForm" :model="payForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
      <el-form-item label="用户编号" prop="number">
        <el-input v-model="payForm.number" disabled class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="user_name">
        <el-input v-model="payForm.user_name" disabled class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="上次表底" prop="last_amount">
        <el-input v-model="payForm.last_amount" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="本次表底" prop="now_amount">
        <el-input v-model="payForm.now_amount" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用水量" prop="use_amount">
        <el-input v-model="payForm.use_amount" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="水费" prop="money">
        <el-input v-model="payForm.money" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="实收水费" prop="real_money">
        <el-input v-model="payForm.real_money" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="closeUpdate" size="small">取 消</el-button>
        <el-button type="primary" @click="updateUserPay('payForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/user/UserPayUpdate.vue